import React from 'react';
import { SuperinterfaceProvider, ThreadDialog, AssistantProvider } from '@superinterface/react';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Creamos un cliente de query específico para este componente
const queryClient = new QueryClient({
     defaultOptions: {
          queries: {
               staleTime: 10000,
          },
     },
});

const SuperinterfaceBot = () => {
     return (
          // Todos los proveedores del bot envuelven solo al componente del bot
          <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
               <QueryClientProvider client={queryClient}>
                    <Theme
                         accentColor="yellow"
                         grayColor="gray"
                         appearance="light"
                    >
                         <SuperinterfaceProvider
                              variables={{
                                   publicApiKey: '6b345a39-e7f9-4f10-b352-a18c6a2a72aa',
                                   assistantId: 'e3c3beef-d54b-45cc-933d-fd66e230034b',
                              }}
                         >
                              <AssistantProvider>
                                   <ThreadDialog />
                              </AssistantProvider>
                         </SuperinterfaceProvider>
                    </Theme>
               </QueryClientProvider>
          </div>
     );
};

export default SuperinterfaceBot;